import { render, staticRenderFns } from "./TotalSalesCollectionsYTDReport.vue?vue&type=template&id=44c93bf1&"
import script from "./TotalSalesCollectionsYTDReport.vue?vue&type=script&lang=js&"
export * from "./TotalSalesCollectionsYTDReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports